var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.usuarioLogado
    ? _c(
        "div",
        [
          _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Cpf/Cnpj"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "CPF/CNPJ:", required: true }
                              }),
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: [
                                      "###.###.###-##",
                                      "##.###.###/####-##"
                                    ],
                                    expression:
                                      "['###.###.###-##', '##.###.###/####-##']"
                                  }
                                ],
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  disabled: true,
                                  name: "cpfCnpj",
                                  value: _vm.cadastrante.pessoa.cpfCnpj
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      830047044
                    )
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 16 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Nome/Razão social"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Nome/Razão social:",
                                  required: true
                                }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  name: "nomeRazaoSocial",
                                  maxlength: "300"
                                },
                                model: {
                                  value: _vm.cadastrante.pessoa.nomeRazaoSocial,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.cadastrante.pessoa,
                                      "nomeRazaoSocial",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "cadastrante.pessoa.nomeRazaoSocial"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      563515760
                    )
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              !_vm.isMaranhao
                ? _c("app-endereco", {
                    attrs: {
                      endereco: _vm.cadastrante.pessoa.endereco,
                      nomeAba: "Cadastrante"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c78d9e58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c78d9e58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/CadastranteSicarf.vue
// module id = null
// module chunks = 